module.exports = __webpack_public_path__ + "static/img/cz.8ffb243f.svg";